import http from '@utils/http';

export const getEdocPublicMe = async () => {
    const res = await http.get('/tenant/edocs-platform/public/me');
    return res?.data?.data ?? null;
};

export const refreshEdocPublicAccessToken = async (refreshToken) => {
    const res = await http.post('/tenant/edocs-platform/public/auth/refresh', { refreshToken });
    return res?.data?.data ?? null;
};

/**
 * Submit signed eDoc to tenant-api.
 * Body: { submission } — creates signed PDF URL on success.
 */
export const submitEdocPublic = async (edocNumber, payload) => {
    const num = String(edocNumber || '').trim();
    const res = await http.post(`/tenant/edocs-platform/public/${encodeURIComponent(num)}/submit`, payload);
    return res?.data?.data ?? null;
};

